import { render, staticRenderFns } from "./bhaktiPromotion.vue?vue&type=template&id=afe64a8c&scoped=true"
import script from "./bhaktiPromotion.vue?vue&type=script&lang=js"
export * from "./bhaktiPromotion.vue?vue&type=script&lang=js"
import style0 from "./bhaktiPromotion.vue?vue&type=style&index=0&id=afe64a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe64a8c",
  null
  
)

export default component.exports